import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { AccordionItemContent, AccordionItemTrigger, AppLink, Badge, Image } from '@cyberkongz/ui';

import { CARDS_SOCIAL_IMPACT } from './content/cards';
import {
  ActiveCardSidebar,
  CardItemWrapper,
  CardsSectionWrapper,
  IntroSectionWrapper,
  introTextStyles,
  ListOfPartnerships,
  useCardsSection,
} from './Shared';

function IntroSection() {
  return (
    <IntroSectionWrapper
      sxSection={{
        backgroundImage: 'url(/static/blueprint/social_impact/intro_bg.jpg)',
      }}
      stylesContainer={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box css={{ maxWidth: ['100%', '62%'], position: 'relative', zIndex: 1 }}>
        <Heading mb={2}>
          Social
          <Heading
            as="span"
            variant="displaySecondary"
            css={{
              position: 'relative',
              top: '0.07em',
              ml: [3, 6],
            }}
          >
            impact
          </Heading>
        </Heading>
        <Text css={{ ...introTextStyles, mb: 8 }}>
          CyberKongz is not only revolutionizing the digital world, but also making a positive
          impact on the physical world through our charitable donations. By supporting organizations
          like Orangutan Outreach, Virunga National Park, and COTAP, CyberKongz demonstrate our
          commitment to conservation, environmental sustainability, and social responsibility. Our
          contributions are helping to protect some of the most vulnerable and important ecosystems
          on the planet.
        </Text>
      </Box>
    </IntroSectionWrapper>
  );
}

function CardsSection() {
  const { activeItem, handleChange } = useCardsSection();
  const activeCardSidebar = activeItem ? (
    <ActiveCardSidebar {...CARDS_SOCIAL_IMPACT[parseInt(activeItem)]} basePath="social_impact" />
  ) : null;

  return (
    <CardsSectionWrapper
      {...{
        activeItem,
        handleChange,
        activeCardSidebar,
        sxBackground: {
          backgroundImage: 'url(/static/blueprint/social_impact/cards_bg.jpg)',
        },
      }}
    >
      {CARDS_SOCIAL_IMPACT.map(({ title, description, image, href, badgeColor, badgeLabel }, i) => (
        <CardItemWrapper key={i} value={i}>
          <AccordionItemTrigger>
            <Flex css={{ justifyContent: 'space-between', alignItems: 'center', flex: 1 }}>
              <Badge badgeColor={badgeColor} withDot>
                {badgeLabel}
              </Badge>
              <Box css={{ display: ['none', 'block'] }}>
                <Image src={`/static/blueprint/social_impact/logo_${image}.png`} alt={title} />
              </Box>
            </Flex>
          </AccordionItemTrigger>
          <AppLink href={href}>
            <Heading size="2xs" css={{ mt: [4, 5], color: 'text' }}>
              {title}
            </Heading>
          </AppLink>
          <AccordionItemContent px={0} pb={0} pt={5}>
            <Box color="textSecondary">{description}</Box>
            <Box display={['block', 'none']}>{activeCardSidebar}</Box>
          </AccordionItemContent>
        </CardItemWrapper>
      ))}
    </CardsSectionWrapper>
  );
}

export function SocialImpactTab() {
  return (
    <>
      <IntroSection />
      <CardsSection />
      <ListOfPartnerships />
    </>
  );
}
